import React from 'react';
import { View, Image } from 'react-native';

import logo_purple from '../../../assets/images/logo_purple.png';

import plan_corp from '../../../assets/images/plan_corp.jpg';
import plan_pers from '../../../assets/images/plan_pers.jpg';
import { AppHeader } from '../../../components/common';
import { styles } from './styles';
import { ImageButton } from '../baseWithButtons';
import { pixelDimensions } from '../../../config/utils';
import { appColors } from '../../../assets/styles/global';

export default function typePlans({ navigation }) {
  return (
    <>
      <AppHeader title="Planos" navigation={navigation} hasBack />
      <View style={styles.content}>
        <View style={{ width: '100%', alignItems: 'center' }}>
          <Image style={styles.logo} source={logo_purple} />
          <ImageButton
            navigation={navigation}
            imageStyles={{ opacity: 0.3 }}
            innerStyle={{ padding: pixelDimensions(9) }}
            colors={['transparent', appColors.darkBlue]}
            image={plan_corp}
            route="Hire Plans"
            text={'PLANOS\nCORPORATIVOS'}
          />
        </View>
        <View style={{ width: '100%', alignItems: 'center' }}>
          <ImageButton
            navigation={navigation}
            imageStyles={{ opacity: 0.3 }}
            innerStyle={{ padding: pixelDimensions(9) }}
            colors={['transparent', appColors.primary]}
            image={plan_pers}
            route={() => navigation.navigate('Profile Trainer', {
              screen: 'Subscriptions',
            })}
            text={'PLANOS\nPESSOAIS'}
          />
        </View>
      </View>
    </>
  );
}
